import React, { Component } from "react";
import { Link } from "react-router-dom";
import auth from "../utils/auth";
import rotas from "./RotasMenu";

class LinksAmbiental extends Component {
    hasPermission = (href) => {
        if (auth.isMasterOrAdmin()) return true;

        let modulos = auth.getUserInfo().menu;
        let menu = modulos?.find((user) => user.item === "ambiental")?.endpoints || [];

        return menu.includes(rotas["ambiental"][href]);
    };

    renderGrupo = (titulo, links) => {
        const linksPermitidos = links.filter(link => this.hasPermission(link.to));

        if (linksPermitidos.length === 0) return null;

        return (
            <div className="hdv-menu-parent">
                <div className="hdv-menu-grupo">
                    {titulo}
                </div>

                <div style={{ display: "flex", flexDirection: "column" }}>
                    {linksPermitidos.map(link => (
                        <Link
                            key={link.to}
                            className="hdv-submenu"
                            to={link.to}
                        >
                            <div className={this.props.pathIncludes(link.match)}>
                                <i className={link.icon}></i> {link.label}
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        );
    };

    render() {
        const sistema = [
            {
                to: "/ambiental/dashboard",
                label: "Dashboard",
                icon: "fa fa-tachometer-alt fa-20px",
                match: "/ambiental/dashboard"
            }
        ];

        const cadastros = [
            {
                to: "/ambiental/outorga",
                label: "Outorga",
                icon: "fa fa-file-contract fa-20px",
                match: "/ambiental/outorga"
            }
        ];

        const retransmissores = [
            {
                to: "/sideccr",
                label: "SIDECC-R",
                icon: "fa fa-network-wired fa-20px",
                match: "/sideccr"
            },
            {
                to: "/mira",
                label: "MIRA",
                icon: "fa fa-network-wired fa-20px",
                match: "/ambiental/mira"
            },
            {
                to: "/ana",
                label: "ANA",
                icon: "fa fa-network-wired fa-20px",
                match: "/ana"
            }
        ];

        const relatorios = [
            {
                to: "/ambiental/relatorio/outorgas",
                label: "Outorga",
                icon: "fa fa-file-alt fa-20px",
                match: "/ambiental/relatorio/outorgas"
            },
            {
                to: "/relatorio-inema",
                label: "Inema",
                icon: "fa fa-file-alt fa-20px",
                match: "/ambiental/relatorio-inema"
            },
            {
                to: "/relatorio-serhma",
                label: "Serhma",
                icon: "fa fa-file-alt fa-20px",
                match: "/ambiental/relatorio-serhma"
            }
        ];

        return (
            <div id="scroll-menu">
                {this.renderGrupo("Sistema", sistema)}
                {this.renderGrupo("Cadastros", cadastros)}
                {this.renderGrupo("Retransmissores", retransmissores)}
                {this.renderGrupo("Relatórios", relatorios)}
            </div>
        );
    }
}

export default LinksAmbiental;